import {ITimeBookingVm, ProxyContainer} from "../Data/Data";
import {LogoutService} from "./LogoutService";

export class AbsenceDataService {

  static serviceId = "AbsenceDataService";
  static $inject = [
    '$proxy',
    LogoutService.serviceId,
  ];

  constructor(private proxy: ProxyContainer,
              private logout: LogoutService) {

  }

  browse(employeeId: number) {
    return this.logout.catchLogoutResponse(this.proxy.Absence.browseMultiple({}, {
      employeeId: employeeId,
      skip: 0,
      take: 30,
    })).then(res => res.data);
  }

  get(absenceId: string) {
    return this.logout.catchLogoutResponse(
      this.proxy.Absence.get({id: absenceId})
      ).then(res => res.data);
  }

  create(absence: ITimeBookingVm) {
    return this.logout.catchLogoutResponse(this.proxy.Absence.createAbsence({
      employeeId: absence.employeeId,
      from: absence.from,
      to: absence.to,
      typeId: absence.timeEntryType.id,
    }));
  }

  save(absence: ITimeBookingVm) {
    return this.logout.catchLogoutResponse(this.proxy.Absence.saveAbsence(absence));
  }

  delete(absenceId: string) {
    return this.logout.catchLogoutResponse(this.proxy.Absence.delete({id: absenceId}));
  }
}